import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import SummaryCardDataCell
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/SummaryCardPicker/SummaryCard/SummaryCardDataCell';

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride('goalAmount', {
    _component: () => SummaryCardDataCell,

  })
  .nameOverride('endDate', {
    _component: () => SummaryCardDataCell,
  });
